import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-password-strength',
  templateUrl: './password-strength.component.html',
  styleUrls: ['./password-strength.component.scss'],
})
export class PasswordStrengthComponent {
  @Input() password: string = '';

  get hasMinimumLength(): boolean {
    return this.password?.length >= 8;
  }

  get hasLowerCase(): boolean {
    return /[a-z]/.test(this.password || '');
  }

  get hasUpperCase(): boolean {
    return /[A-Z]/.test(this.password || '');
  }

  get hasDigit(): boolean {
    return /[0-9]/.test(this.password || '');
  }

  get hasSpecialChar(): boolean {
    return /[#$^+=!*()@%&.,+_<>-]/.test(this.password || '');
  }
}
